module.exports = __webpack_public_path__ + "static/senior-4-a698c6acc7e95432c4365ed033e039ee.png";